import React from 'react'
import Header from '../../Home/Header';
import Software from './Software';
import Footer from '../../Home/Footer';
import SoftwareProducts from '../Product/SoftwareProducts';

const ProductSoftware = () => {
  return (
    <div>
    <Header />
    <SoftwareProducts />
    <Software />
    <Footer />
</div>
  )
}

export default ProductSoftware